export default {
    "updated": "Produsul a fost actualizată cu succes.",
}
